/* --------------------------------------------------------------------------
   Sticky + shrinking store header (mirrors the main touchdro.com site).

   - On load / resize: measure the actual rendered header height and push
     <main> down by that amount so fixed-positioned content doesn't overlap.
   - On scroll: once we've scrolled past 50px, add `.shrink` so the header
     reduces its padding + logo size; remove it when we scroll back to top.
   -------------------------------------------------------------------------- */

function syncMainOffsetToHeader() {
  var header = document.querySelector('.site-header');
  var main = document.querySelector('main');
  if (!header || !main) return;
  // Exact header height — no padding buffer — so full-bleed hero sections
  // butt right up against the dark header with no white strip between them.
  // Sections that want breathing room can add their own top padding.
  var headerHeight = header.offsetHeight;
  main.style.marginTop = headerHeight + 'px';
}

window.addEventListener('load', syncMainOffsetToHeader);
window.addEventListener('resize', syncMainOffsetToHeader);

window.addEventListener('scroll', function () {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var header = document.querySelector('.site-header');
  if (!header) return;

  var wasShrunk = header.classList.contains('shrink');

  if (scrollTop > 50) {
    header.classList.add('shrink');
  } else {
    header.classList.remove('shrink');
  }

  /* When the shrink state changes the header height changes, so
     re-sync the <main> top margin to avoid overlap / gaps.
     The header uses a CSS transition on padding, so we wait for
     transitionend to measure the final height. We also sync
     immediately for the shrink→true case (header gets smaller)
     so content doesn't jump. */
  if (header.classList.contains('shrink') !== wasShrunk) {
    if (header.classList.contains('shrink')) {
      /* Shrinking — safe to sync immediately (header is getting smaller). */
      syncMainOffsetToHeader();
    } else {
      /* Expanding — wait for the transition to finish so we measure
         the full expanded height, not the mid-animation height. */
      header.addEventListener('transitionend', function onDone(e) {
        if (e.propertyName === 'padding' || e.propertyName === 'padding-top') {
          header.removeEventListener('transitionend', onDone);
          syncMainOffsetToHeader();
        }
      });
      /* Fallback in case transitionend doesn't fire (e.g. reduced motion). */
      setTimeout(syncMainOffsetToHeader, 350);
    }
  }
});

/* --------------------------------------------------------------------------
   Mobile nav toggle (mirrors main touchdro.com site main.js).
   -------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.nav-toggle');
  var overlay = document.querySelector('.nav-overlay');

  if (!toggle) return;

  function openNav() {
    document.body.classList.add('nav-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
  }

  function closeNav() {
    document.body.classList.remove('nav-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  }

  toggle.addEventListener('click', function () {
    if (document.body.classList.contains('nav-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  if (overlay) {
    overlay.addEventListener('click', closeNav);
  }
});
